import React from 'react';
import { useTranslate } from 'nucleus-text';

import { useFooterStyle } from '@hooks/style/useFooterStyle';
import { CustomText } from '@components/textFields/CustomText';

type CopyrightProps = {
  testID: string;
};

export const Copyright = ({ testID }: CopyrightProps): JSX.Element => {
  const { translate } = useTranslate();
  const { copyright } = useFooterStyle();

  return (
    <CustomText
      testID={`${testID}_copyright`}
      as={'p'}
      text={translate('footer_copyright', { year: new Date().getFullYear() })}
      typeStyle={copyright}
    />
  );
};
